import * as React from 'react'
import classnames from 'classnames'
import { Props } from './types'
import './styles.scss'

export class Header extends React.Component<Props> {
  constructor(props: Props) {
    super(props)

    this.state = {}
  }

  render() {
    const { components, classNames } = this.props

    if (!components || !Array.isArray(components) || components?.length === 0) return null
    if (!components.some(comp => typeof comp === 'object')) return null

    return (
      <div className={classnames('header', classNames)}>
        {components.map((Comp: JSX.Element, index: number) => {
          if (index % 2 === 0) {
            return (
              <div key={`${index}__header__left`} className="header__left">
                {Comp}
              </div>
            )
          }

          return (
            <div key={`${index}__header__right`} className="header__right">
              {Comp}
            </div>
          )
        })}
      </div>
    )
  }
}
